import { Label as LabelDs } from "@packages/ds";
import styled from "styled-components";

import ButtonDs, { IconControl as IconControlDs } from "ds/Button";

export const ListFieldLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  position: relative;
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  flex-shrink: 0;
  align-items: baseline;
  gap: 26px;
  margin-bottom: 41px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const InputLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: start;
`;

export const IconControl = styled(IconControlDs)`
  margin-top: -8px;
`;

export const RemoveButton = styled(ButtonDs)`
  margin-left: 32px;
  margin-top: 30px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  margin-bottom: 8px;
  gap: 8px;
`;

export const InputLabel = styled(LabelDs)`
  margin-bottom: 0;
`;
